import React from "react";
import WYSIWYGEditor from "components/WYSIWYGEditor";
import NewsletterPhonePreview from "components/NewsletterPhonePreview";

export default class Page3 extends React.Component {
  state = {
    headers: [
      {
        header: "",
        text: ""
        // text2: ""
      }
    ]
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  componentDidMount = () => {
    this.initialize();
  };

  initialize = () => {
    console.log("Page 3:");
    console.log("Global Obj: ", this.props.obj);

    var temp = this.state.headers;
    temp[0].header = this.props.obj[0].magazine1.page3.header;
    temp[0].text = this.props.obj[0].magazine1.page3.text;

    this.setState({
      headers: temp
    });

    console.log("Local Obj: ", this.state.magazine);
    console.log("Tepm Obj: ", temp);
  };

  handleChange = (event, key) => {
    let temp = this.state.headers;

    temp[0][key] = event.target.value;

    this.setState({ headers: temp });
  };

  handleEditorChange = event => {
    let temp = this.state.headers;

    temp[0].text = event.target.value;

    this.setState({
      headers: temp
    });
  };

  handleEditorUpdate = val => {
    let temp = this.state.headers;

    temp[0].text = val;

    this.setState({
      headers: temp
    });
  };

  checkIfEmpty = page => {
    var temp = this.state.headers[0];

    if (!temp.header || !temp.text) {
      alert("All fields are required");
      return;
    }
    this.props.changePage(this.state.headers, page);
  };

  // 단계 표시기 (현재 3단계: 마무리 확인)
  renderSteps() {
    const steps = ["기본 정보", "본문 내용", "마무리 확인"];
    const current = 2;
    return (
      <ol className="mb-8 flex flex-wrap items-center gap-3">
        {steps.map((label, i) => (
          <li key={i} className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <span
                className={
                  "flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold " +
                  (i === current
                    ? "bg-sky-500 text-white shadow"
                    : i < current
                    ? "bg-sky-200 text-sky-700"
                    : "bg-gray-200 text-gray-500")
                }
              >
                {i + 1}
              </span>
              <span
                className={
                  "text-sm font-medium " +
                  (i === current ? "text-sky-600" : "text-gray-400")
                }
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <span className="hidden h-px w-8 bg-gray-300 sm:block" />
            )}
          </li>
        ))}
      </ol>
    );
  }

  render() {
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-6xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-2 text-2xl font-bold">🎉 3단계 · 마무리 확인</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              마지막 페이지입니다! 세 번째 페이지의 소제목과 본문을 작성하세요.
              본문은 <span className="font-semibold">글씨 크기·굵게·색상</span> 등을
              자유롭게 꾸밀 수 있습니다. 다 쓰셨으면{" "}
              <span className="font-semibold">[한눈에 보기]</span>로 미리 확인하거나
              바로 <span className="font-semibold">[{this.props.edit ? "저장" : "만들기"}]</span>
              를 누르세요.
            </p>
          </div>

          {/* 단계 표시기 */}
          {this.renderSteps()}

          <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
            <div className="min-w-0 lg:flex-1">
          {/* 마지막 페이지 내용 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                ✎
              </span>
              <h3 className="text-lg font-bold text-gray-800">
                마지막 페이지 내용
              </h3>
            </div>
            <p className="mb-4 ml-9 text-sm text-gray-500">
              예) 소제목 "맺음말" → 본문에 감사 인사나 다음 호 예고를 자유롭게
              작성하세요.
            </p>

            <div className="ml-0 space-y-5 sm:ml-9">
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  소제목 <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="예) 맺음말"
                  defaultValue={this.props.obj[0].magazine1.page3.header}
                  className={this.inputCls}
                  onChange={event => this.handleChange(event, "header")}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  본문 내용 <span className="text-rose-500">*</span>
                </label>
                <p className="mb-2 text-xs text-gray-400">
                  아래 편집기에서 글씨를 굵게 하거나 색을 바꾸는 등 자유롭게 꾸밀
                  수 있어요.
                </p>
                <div className="rounded-lg border border-gray-200 p-1">
                  <WYSIWYGEditor
                    editorId="pageContent"
                    onChange={event => this.handleEditorChange(event)}
                    updateValues={val => this.handleEditorUpdate(val)}
                    defaultValue={this.props.obj[0].magazine1.page3.text}
                    description="내용을 입력하세요"
                  />
                </div>
              </div>
            </div>
          </section>
            </div>

            {/* 실시간 앱 미리보기 */}
            <div className="w-full lg:w-[340px] lg:shrink-0">
              <div className="lg:sticky lg:top-4">
                <NewsletterPhonePreview
                  pageNames={this.props.pageNames}
                  date={this.props.obj[0].date}
                  noOfWeeks={this.props.obj[0].noOfWeeks}
                  magazine={{
                    page1: this.props.obj[0].magazine1.page1,
                    page2: this.props.obj[0].magazine1.page2,
                    page3: this.state.headers[0]
                  }}
                  activePage={2}
                />
              </div>
            </div>
          </div>

          {/* 하단 네비게이션 */}
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <button
              type="button"
              className="inline-flex items-center justify-center gap-1 rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50"
              onClick={() => this.props.changePage(this.state.headers, "previous")}
            >
              ← 이전 단계
            </button>

            <div className="flex items-center justify-end gap-3">
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-xl border border-sky-300 bg-white px-5 py-2.5 text-sm font-semibold text-sky-600 shadow-sm transition hover:bg-sky-50"
                onClick={() => this.checkIfEmpty("next")}
              >
                👁️ 한눈에 보기
              </button>
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                onClick={() => this.props.saveToDB(this.state.headers)}
              >
                {this.props.edit ? "💾 저장" : "✅ 만들기"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
